function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import identity from 'lodash.identity';
import { ListSubheader } from '@material-ui/core';
const OptionGroup = forwardRef(({
  children,
  ...props
}, ref) => React.createElement(ListSubheader, _extends({
  style: {
    backgroundColor: 'white'
  }
}, props, {
  ref: ref
}), children));

const withGroupedOptionHelpers = Component => props => {
  Component.propTypes = { ...Component.propsTypes,
    getOptionType: PropTypes.func
  };
  Component.defaultProps = { ...Component.defaultProps,
    getOptionType: () => undefined
  };
  return React.createElement(Component, props);
};

const withStandardOptionHelpers = Component => props => {
  Component.propTypes = { ...Component.propTypes,
    getOptionKey: PropTypes.func,
    getOptionLabel: PropTypes.func,
    getOptionValue: PropTypes.func
  };
  Component.defaultProps = { ...Component.defaultProps,
    getOptionKey: identity,
    getOptionLabel: identity,
    getOptionValue: identity
  };
  return React.createElement(Component, props);
};

export { OptionGroup, withGroupedOptionHelpers, withStandardOptionHelpers };